import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "onChange", "error", "errorMessage", "disabled", "required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isNull } from '@infl-ts/util-function';
import { Box, outlinedInputClasses, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { formatISO, isValid, parseISO } from 'date-fns';
import { flow, pipe } from 'fp-ts/function';
import * as Pred from 'fp-ts/Predicate';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { getErrorMessage } from './form-helpers';
import { jsx as _jsx } from "react/jsx-runtime";
var isValidDateString = flow(parseISO, isValid);

var DatePickerFormField = function DatePickerFormField(_ref) {
  var label = _ref.label,
      _onChange = _ref.onChange,
      error = _ref.error,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'Please provide a valid date' : _ref$errorMessage,
      disabled = _ref.disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "DatePickerFormField",
    "data-source-file": "date-picker-form-field.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
        rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
          required: required,
          validate: pipe(isNull, Pred.or(isValidDateString))
        }),
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/_jsx(DatePicker, _objectSpread(_objectSpread({}, field), {}, {
            inputFormat: "yyyy-MM-dd",
            mask: "____-__-__",
            onChange: function onChange(value) {
              var date = value && isValid(value) ? formatISO(value) : '';
              field.onChange(date);
              if (_onChange) _onChange(date);
            },
            label: label || t('yyyy-mm-dd'),
            disabled: disabled,
            OpenPickerButtonProps: {
              sx: {
                color: function color(t) {
                  return t.palette.text.secondary;
                }
              }
            },
            renderInput: function renderInput(params) {
              var _ref3;

              return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
                sx: [{
                  width: 1
                }, !!error && (_ref3 = {}, _defineProperty(_ref3, "& .".concat(outlinedInputClasses.notchedOutline), {
                  borderColor: function borderColor(t) {
                    return error ? t.palette.error.main : undefined;
                  }
                }), _defineProperty(_ref3, "&:hover .".concat(outlinedInputClasses.notchedOutline), {
                  borderColor: function borderColor(t) {
                    return error ? t.palette.error.main : undefined;
                  }
                }), _ref3)],
                required: required,
                error: !!error,
                helperText: error && /*#__PURE__*/_jsx(Box, {
                  component: "span",
                  sx: {
                    color: function color(t) {
                      return t.palette.error.main;
                    }
                  },
                  children: t(getErrorMessage(error, errorMessage))
                }),
                FormHelperTextProps: {
                  sx: {
                    ml: 0
                  }
                },
                size: "small"
              }, params), {}, {
                inputProps: _objectSpread(_objectSpread({}, params === null || params === void 0 ? void 0 : params.inputProps), {}, {
                  placeholder: ' '
                }),
                InputLabelProps: _objectSpread(_objectSpread({}, params === null || params === void 0 ? void 0 : params.InputLabelProps), {}, {
                  sx: {
                    color: function color(t) {
                      return error ? t.palette.error.main : t.palette.text.primary;
                    }
                  },
                  shrink: true
                })
              }));
            }
          }));
        }
      }));
    }
  });
};

export default DatePickerFormField;